module.exports = __webpack_public_path__ + "img/mPfp44.f6743991.png";